import faq from '@link/share/i18n/faq/zt';
import privacy from '@link/share/i18n/privacy/zt';
import terms from '@link/share/i18n/terms/zt';
import book from './book';
import booking from './booking';
import common from './common';
import law from './law';
import shinkansen from './shinkansen';

export default {
  ...common,
  views: {
    ...faq,
    ...privacy,
    ...terms,
    ...shinkansen,
    ...booking,
    ...book,
    ...law
  }
};
